import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Dashboard from '../../Dashboard';
import Orgcom from './../admin/_org/Orgcom';
import IndexRe from './../admin/_report/IndexRe';
import Profile from './_profile/Profile';
import STSIndex from './_sts/STSIndex';
import Report from './../admin/_report_admin/ReportIndex';


export default class AdminView extends React.Component {
   render() {
      return (
         <div>
            <Switch>
               <Route path={"/d/dashboard"} name="dashboard" component={Dashboard} />               
               <Route path={"/d/sts"} name="sts" component={STSIndex} />
               <Route path={"/d/report"} name="org" component={Report} />
               <Route path={"/d/org"} name="org" component={Orgcom} />
               <Route path={"/d/profile"} name="profile" component={Profile} />
               <Route path={"/d/re"} name="rencana-realisasi" component={IndexRe} />
               <Redirect from="/d" to="/d/dashboard" />
            </Switch>
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/verificator/verificator.view.js